import React, { useState, useEffect, useMemo } from 'react';
import { Paginator } from 'primereact/paginator';

const UserListing = ({ data, onEdit, onDelete, isLoading, canManage, onOpenScholar, onViewCV, onToggleRestrict, currentUserEmail, onMonitor }) => {
    const [first, setFirst] = useState(0);
    const [isDesktop, setIsDesktop] = useState(true);
    const [sortOrder, setSortOrder] = useState(null);
    const rows = 20;

    useEffect(() => {
        const handleResize = () => {
            setIsDesktop(window.innerWidth > 992);
        };

        handleResize();
        window.addEventListener('resize', handleResize);

        return () => window.removeEventListener('resize', handleResize);
    }, []);

    useEffect(() => {
        setFirst(0);
    }, [sortOrder]);

    useEffect(() => {
        if (data.length > 0 && first >= data.length) {
            const maxFirst = Math.max(0, Math.ceil(data.length / rows) - 1) * rows;
            setFirst(maxFirst);
        }
    }, [data.length, first, rows]);

    const getLoginTimestamp = (lastLogin) => {
        if (!lastLogin) return 0;

        if (typeof lastLogin === 'string' && lastLogin.includes('/Date')) {
            return parseInt(lastLogin.replace(/\/Date\((.*?)\)\//, '$1'), 10);
        }

        const date = new Date(lastLogin);
        return isNaN(date.getTime()) ? 0 : date.getTime();
    };

    const sortedData = useMemo(() => {
        if (!sortOrder) return data;

        return [...data].sort((a, b) => {
            const timeA = getLoginTimestamp(a.LastLogin);
            const timeB = getLoginTimestamp(b.LastLogin);

            if (sortOrder === 'asc') {
                return timeA - timeB;
            } else {
                return timeB - timeA;
            }
        });
    }, [data, sortOrder]);

    const paginatedData = sortedData.slice(first, first + rows);

    const onPageChange = (event) => {
        setFirst(event.first);
    };

    const handleSortClick = () => {
        if (sortOrder === null) setSortOrder('desc');
        else if (sortOrder === 'desc') setSortOrder('asc');
        else setSortOrder(null);
    };

    return (
        <div className="table-card" style={{ overflowX: 'auto', background: '#fff', borderRadius: '8px', boxShadow: '0 2px 4px rgba(0,0,0,0.05)', paddingBottom: '10px' }}>
            {isLoading ? (
                <div style={{ textAlign: 'center', padding: '50px' }}>
                    <i className="fa-solid fa-circle-notch fa-spin fa-2x" style={{ color: '#3498db', marginRight: '10px' }}></i>
                    <p style={{ marginTop: '10px', color: '#666' }}>Đang tải dữ liệu</p>
                </div>
            ) : data.length === 0 ? (
                <div style={{ textAlign: 'center', padding: '60px 20px', color: '#666' }}>
                    <i className="fa-solid fa-users-slash" style={{ fontSize: '60px', color: '#5dade2', marginBottom: '15px' }}></i>
                    <h3 style={{ color: '#e74c3c', margin: '0 0 10px 0' }}>Không tìm thấy người dùng</h3>
                </div>
            ) : (
                <>
                    <table className="custom-table" style={{ minWidth: isDesktop ? '1500px' : '100%' }}>
                        <thead>
                            <tr>
                                <th width="3%" style={{ textAlign: 'center' }}>STT</th>
                                <th width="10%">HỌ ĐỆM</th>
                                <th width="7%">TÊN</th>
                                <th width="10%">ĐƠN VỊ</th>
                                <th width="15%" style={{ textAlign: 'center' }}>LINK GOOGLE SCHOLAR</th>
                                <th width="8%" style={{ textAlign: 'center' }}>LÝ LỊCH KHOA HỌC</th>
                                <th width="8%">USERNAME</th>
                                <th width="12%">EMAIL</th>
                                <th width="8%">VAI TRÒ</th>
                                <th width="6%">ĐIỆN THOẠI</th>
                                <th
                                    width="8%"
                                    onClick={handleSortClick}
                                    style={{ cursor: 'pointer', userSelect: 'none' }}
                                    title="Nhấn để sắp xếp"
                                >
                                    LẦN CUỐI ĐN
                                    <span style={{ marginLeft: '6px', color: sortOrder ? '#333' : '#ccc' }}>
                                        {sortOrder === 'asc' ? (
                                            <i className="fa-solid fa-sort-up"></i>
                                        ) : sortOrder === 'desc' ? (
                                            <i className="fa-solid fa-sort-down"></i>
                                        ) : (
                                            <i className="fa-solid fa-sort"></i>
                                        )}
                                    </span>
                                </th>
                                <th width="4%" style={{ textAlign: 'center' }}>ĐÃ XÁC NHẬN</th>
                                <th width="4%" style={{ textAlign: 'center' }}>ĐÃ KHÓA</th>
                                <th width="5%" style={{ textAlign: 'center' }}>CHỨC NĂNG</th>
                            </tr>
                        </thead>
                        <tbody>
                            {paginatedData.map((item, index) => {
                                const actualIndex = first + index + 1;

                                return (
                                    <tr key={item.Id}>
                                        <td style={{ textAlign: 'center' }}>{actualIndex}</td>
                                        <td>{item.LastName}</td>
                                        <td style={{ fontWeight: '500' }}>{item.FirstName}</td>
                                        <td style={{ color: item.DepartmentName ? 'inherit' : '#999', fontStyle: item.DepartmentName ? 'normal' : 'italic' }}>
                                            {item.DepartmentName || 'Chưa cập nhật'}
                                        </td>

                                        <td style={{ textAlign: 'center' }}>
                                            {item.GoogleScholarLink ? (
                                                <a href={item.GoogleScholarLink} target="_blank" rel="noreferrer" style={{ color: '#007bff', textDecoration: 'none', fontWeight: 'bold' }}>
                                                    Link Scholar <i className="fa-solid fa-arrow-up-right-from-square" style={{ fontSize: '11px' }}></i>
                                                </a>
                                            ) : (
                                                <div style={{ color: '#ffc107', fontStyle: 'italic', display: 'flex', alignItems: 'center', gap: '5px', justifyContent: 'center' }}>
                                                    <i className="fa-solid fa-triangle-exclamation" style={{ fontSize: '16px' }}></i>
                                                    Chưa cập nhật
                                                </div>
                                            )}
                                        </td>

                                        <td style={{ textAlign: 'center' }}>
                                            <div
                                                className="icon-wrapper-CV"
                                                onClick={() => onViewCV(item)}
                                                style={{ cursor: 'pointer', display: 'inline-block' }}
                                                title="Xem Lý lịch khoa học toàn trang"
                                            >
                                                <i className="fa-solid fa-address-card" style={{ color: '#27ae60', fontSize: '18px' }}></i>
                                            </div>
                                        </td>

                                        <td>{item.Username}</td>
                                        <td>{item.Email}</td>
                                        <td>{item.RoleName}</td>
                                        <td>{item.Phone}</td>
                                        <td>
                                            {(() => {
                                                if (!item.LastLogin) return 'Chưa từng ĐN';

                                                if (typeof item.LastLogin === 'string' && item.LastLogin.includes('/Date')) {
                                                    const milli = parseInt(item.LastLogin.replace(/\/Date\((.*?)\)\//, '$1'), 10);
                                                    return new Date(milli).toLocaleString('vi-VN');
                                                }

                                                const date = new Date(item.LastLogin);
                                                return isNaN(date.getTime()) ? 'Sai định dạng' : date.toLocaleString('vi-VN');
                                            })()}
                                        </td>
                                        <td style={{ textAlign: 'center' }}>
                                            {item.IsActive ? <i className="fa-solid fa-circle-check" style={{ color: '#28a745', fontSize: '16px' }}></i> : ''}
                                        </td>
                                        <td style={{ textAlign: 'center' }}>
                                            {item.IsLocked ? <i className="fa-solid fa-lock" style={{ color: '#dc3545', fontSize: '16px' }}></i> : ''}
                                        </td>
                                        <td>
                                            <div className="action-group" style={{ display: 'flex', gap: '10px', justifyContent: 'center' }}>
                                                {(currentUserEmail === 'namnk@due.edu.vn' || currentUserEmail === 'chau.dn@due.edu.vn') && (
                                                    <div className="icon-wrapper monitor-wrapper" onClick={() => onMonitor(item)} style={{ cursor: 'pointer' }} title="Giám sát log hoạt động">
                                                        <i className="fa-solid fa-clipboard-list monitor-icon" style={{ color: '#9b59b6' }}></i>
                                                    </div>
                                                )}
                                                {currentUserEmail === 'namnk@due.edu.vn' && (
                                                    <div className="icon-wrapper restrict-wrapper" onClick={() => onToggleRestrict(item)} style={{ cursor: 'pointer' }} title={item.IsAddRestricted ? "Gỡ hạn chế Thêm mới" : "Hạn chế Thêm mới"}>
                                                        <i className={`fa-solid ${item.IsAddRestricted ? 'fa-unlock' : 'fa-ban'}`} style={{ color: item.IsAddRestricted ? '#28a745' : '#856404' }}></i>
                                                    </div>
                                                )}
                                                <div className="icon-wrapper edit-wrapper" onClick={() => onEdit(item)} style={{ cursor: 'pointer' }}>
                                                    <i className="fa-solid fa-pen edit-icon" style={{ color: '#3498db' }}></i>
                                                </div>

                                                {/* 
                                                <div className="icon-wrapper delete-wrapper" onClick={() => onDelete(item.Id)} style={{ cursor: 'pointer' }}>
                                                    <i className="fa-solid fa-trash delete-icon" style={{ color: '#e74c3c' }}></i>
                                                </div> 
                                                */}
                                            </div>
                                        </td>
                                    </tr>
                                );
                            })}
                        </tbody>
                    </table>

                    {data.length > rows && (
                        <div style={{ marginTop: '15px', borderTop: '1px solid #e9ecef', paddingTop: '10px' }}>
                            <Paginator
                                first={first}
                                rows={rows}
                                totalRecords={data.length}
                                onPageChange={onPageChange}
                                template="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport"
                                currentPageReportTemplate="Đang hiển thị {first} đến {last} trong tổng số {totalRecords} tài khoản"
                                style={{ background: 'transparent', border: 'none' }}
                            />
                        </div>
                    )}
                </>
            )}
        </div>
    );
};

export default UserListing;